/* ============================================================
 * MODIFIED BY CLAUDE — 2026-05-06 — VERSION FIX-20260506-223801 (plugin polyfill)
 * If you see this comment, you are looking at the PATCHED source.
 * Patches: safeInit wrapper, Flickity guard, gallery recovery,
 *          jQuery plugin restoration (defends against apps like
 *          Zepto/pplr_common that load their own jQuery and wipe
 *          out theme plugins like flickity/fancybox/zoom).
 * 2026-09-18: Shopify Planet decorative icon alt-text fix (SC 1.1.1) —
+ *          see self-contained block near the end of the file.
 * ============================================================ */

/* CRITICAL: Capture references to theme's jQuery and its plugins NOW,
 * while this script is still running synchronously after vendors.js.
 * Some third-party apps (Zepto/pplr_common.js, Monster Upsells, etc.)
 * load their own jQuery synchronously without noConflict(), replacing
 * window.$ and window.jQuery. This wipes out the theme's plugins
 * (flickity, fancybox, zoom) that vendors.js registered.
 * We capture them here so we can restore them before they're needed. */
(function () {
  if (typeof window.jQuery !== 'undefined' && window.jQuery.fn) {
    window.__themeJQuery = {
      jQuery: window.jQuery,
      $: window.$,
      flickity: window.jQuery.fn.flickity,
      fancybox: window.jQuery.fn.fancybox,
      fancyboxStatic: window.jQuery.fancybox,
      zoom: window.jQuery.fn.zoom
    };
    console.log('[theme] Captured jQuery ' + (window.jQuery.fn.jquery || '?') +
                ' with plugins: flickity=' + (typeof window.jQuery.fn.flickity === 'function') +
                ', fancybox=' + (typeof window.jQuery.fn.fancybox === 'function') +
                ', zoom=' + (typeof window.jQuery.fn.zoom === 'function'));
  } else {
    console.warn('[theme] jQuery not present at app.js execution; cannot capture plugins');
  }
})();

window.__restoreThemeJQuery = function () {
  var $ = window.jQuery;
  if (!$ || !$.fn) return false;
  var restored = [];

  // Ensure $ === jQuery
  if (window.$ !== window.jQuery) { window.$ = window.jQuery; }

  // Restore from captured originals if available
  if (window.__themeJQuery) {
    var t = window.__themeJQuery;
    if (typeof $.fn.flickity !== 'function' && typeof t.flickity === 'function') {
      $.fn.flickity = t.flickity; restored.push('$.fn.flickity (from capture)');
    }
    if (typeof $.fn.fancybox !== 'function' && typeof t.fancybox === 'function') {
      $.fn.fancybox = t.fancybox; restored.push('$.fn.fancybox (from capture)');
    }
    if (!$.fancybox && t.fancyboxStatic) {
      $.fancybox = t.fancyboxStatic; restored.push('$.fancybox (from capture)');
    }
    if (typeof $.fn.zoom !== 'function' && typeof t.zoom === 'function') {
      $.fn.zoom = t.zoom; restored.push('$.fn.zoom (from capture)');
    }
  }

  // POLYFILL Flickity from window.Flickity class if jQuery plugin still missing.
  // This is needed when vendors.js's IIFE registered the plugin on a different
  // jQuery (e.g. an app's jQuery that briefly overrode the global).
  if (typeof $.fn.flickity !== 'function' && typeof window.Flickity === 'function') {
    $.fn.flickity = function (arg) {
      var args = Array.prototype.slice.call(arguments, 1);
      var firstReturnValue;
      this.each(function (i, el) {
        var instance = window.Flickity.data ? window.Flickity.data(el) : null;
        if (typeof arg === 'string') {
          if (instance && typeof instance[arg] === 'function') {
            var rv = instance[arg].apply(instance, args);
            if (firstReturnValue === undefined) firstReturnValue = rv;
          }
        } else {
          if (!instance) {
            try { new window.Flickity(el, arg); } catch (e) { console.warn('[theme] Flickity polyfill instantiate failed:', e); }
          } else if (arg && typeof instance.option === 'function') {
            instance.option(arg);
          }
        }
      });
      return firstReturnValue !== undefined ? firstReturnValue : this;
    };
    restored.push('$.fn.flickity (polyfill from window.Flickity)');
  }

  // POLYFILL $.fn.fancybox using $.fancybox.open if static is present
  if (typeof $.fn.fancybox !== 'function' && $.fancybox && typeof $.fancybox.open === 'function') {
    $.fn.fancybox = function (options) {
      var $items = this;
      return $items.on('click.fancybox-polyfill', function (e) {
        e.preventDefault();
        try { $.fancybox.open($items, options); } catch (err) { console.warn('[theme] fancybox open failed:', err); }
      });
    };
    restored.push('$.fn.fancybox (polyfill)');
  }

  // POLYFILL no-op stubs for non-critical plugins so theme code doesn't crash
  if (typeof $.fn.zoom !== 'function') {
    $.fn.zoom = function () { return this; };
    restored.push('$.fn.zoom (no-op stub)');
  }
  if (typeof $.fn.waypoint !== 'function') {
    $.fn.waypoint = function () { return this; };
    restored.push('$.fn.waypoint (no-op stub)');
  }
  if (!$.fancybox) {
    $.fancybox = { defaults: { mobile: {} }, open: function () {}, close: function () {}, destroy: function () {}, getInstance: function () { return null; } };
    restored.push('$.fancybox (no-op stub)');
  } else {
    // Make sure defaults.mobile exists so chained assignments don't crash
    if (!$.fancybox.defaults) $.fancybox.defaults = {};
    if (!$.fancybox.defaults.mobile) $.fancybox.defaults.mobile = {};
  }

  if (restored.length) {
    console.log('[theme] Plugin restore: ' + restored.join(', '));
    return true;
  }
  return false;
};

/******/ (() => { // webpackBootstrap
/* eslint-disable */
rimg.shopify.init('[data-rimg="lazy"]', {
  round: 1
});
const sections = new ShopifySectionsManager();
sections.register('age-gate', section => new AgeGate.PageAgeGate(section));
const ageGatePage = document.getElementById('age-gate-page');
if (ageGatePage) {
  new AgeGate.SiteAgeGate(ageGatePage);
}
document.addEventListener('DOMContentLoaded', function () {
  // FIRST: restore theme's jQuery + plugins if a 3rd-party app overwrote them
  if (typeof window.__restoreThemeJQuery === 'function') {
    window.__restoreThemeJQuery();
  }
    // [glg-fix] 2026-07-27 — Re-run jQuery/plugin restoration on a delay too,
  // since third-party scripts (Zepto/pplr_common) can load their own jQuery
  // well after DOMContentLoaded, undoing the earlier restore.
  [1000, 2000, 3000, 5000, 8000].forEach(function (delay) {
    setTimeout(function () {
      if (typeof window.__restoreThemeJQuery === 'function') {
        window.__restoreThemeJQuery();
      }
    }, delay);
  });
  function safeInit(label, fn) {
    try { fn(); } catch (e) {
      console.warn('[theme] ' + label + ' init failed:', e);
      // Try restoring jQuery and retrying once — some apps replace jQuery between init calls
      if (typeof window.__restoreThemeJQuery === 'function' && window.__restoreThemeJQuery()) {
        try { fn(); console.log('[theme] ' + label + ' init succeeded after jQuery restore'); }
        catch (e2) { console.warn('[theme] ' + label + ' init still failing after restore:', e2); }
      }
    }
  }
  safeInit('utils.enableDisclosure', () => window.utils.enableDisclosure());
  if (window.Flickity && window.Flickity.prototype) {
    const oldFlickityCreate = window.Flickity.prototype._create;
    window.Flickity.prototype._create = function () {
      const that = this;
      if (this.element.addEventListener) {
        this.element.addEventListener('load', () => {
          that.onresize();
        }, true);
      }
      this._create = oldFlickityCreate;
      return oldFlickityCreate.apply(this, arguments);
    };
  } else {
    console.warn('[theme] Flickity not available at DOMContentLoaded; sliders will not initialize.');
  }

  // Support for background images with new Lazysizes library
  document.addEventListener('lazyloaded', e => {
    let bg = e.target.getAttribute('data-bg');
    const mobileBg = e.target.getAttribute('data-mobile-bg');
    if (bg) {
      if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
        bg = mobileBg;
      }
      e.target.style.backgroundImage = `url(${bg})`;
    }
  });

  // Call to flickity fix for sliders on IOS
  safeInit('imageFunctions.flickityIosFix', () => window.imageFunctions.flickityIosFix());
  safeInit('header', () => window.header.init());
  safeInit('mobileSearch', () => window.mobileSearch.init());
  safeInit('siteOverlay', () => window.siteOverlay.init());
  safeInit('meganavManager', () => window.meganavManager.injectAll());
  if (window.PXUTheme && window.PXUTheme.theme_settings && window.PXUTheme.theme_settings.enable_autocomplete) {
    safeInit('predictiveSearch', () => window.predictiveSearch.init());
  }
  safeInit('utils.initializeSectionWrapper', () => window.utils.initializeSectionWrapper());
  safeInit('slideshow', () => window.slideshow.init());
  safeInit('testimonials', () => window.testimonials.init());
  safeInit('video', () => window.video.init());
  safeInit('gallery', () => window.gallery.init());
  safeInit('videoFeature.setupVideoPlayer', () => window.videoFeature.setupVideoPlayer());
  safeInit('featuredPromotions', () => window.featuredPromotions.init());
  safeInit('featuredCollection', () => window.featuredCollection.init());
  safeInit('logoList', () => window.logoList.init());
  safeInit('collectionSidebarFilter', () => window.collectionSidebarFilter.init());
  safeInit('cart', () => window.cart.init());
  safeInit('map', () => window.map.init());
  safeInit('shoppableImage', () => window.shoppableImage.init());
  safeInit('productPage', () => window.productPage.init());
  safeInit('productPage.runOptionSelector', () => window.productPage.runOptionSelector());
  safeInit('productPage.initializeQuantityBox', () => window.productPage.initializeQuantityBox());
  safeInit('recentlyViewed', () => window.recentlyViewed.init());
  safeInit('sidebarAccordions', () => window.sidebarAccordions.init());

  /* Gallery resilience for app conflicts (e.g., Zepto Personalizer) */
  function forceLoadGalleryImages() {
    try {
      $('.js-product-gallery img.lazyload, .product_gallery_nav img.lazyload').each(function () {
        var $img = $(this);
        if ($img.attr('data-srcset')) { $img.attr('srcset', $img.attr('data-srcset')); }
        if ($img.attr('data-src')) { $img.attr('src', $img.attr('data-src')); }
        $img.removeClass('lazyload').addClass('lazyloaded');
      });
    } catch (e) {}
  }
  function softResizeGallery() {
    try {
      var $g = $('.js-product-gallery');
      if ($g.length && $g.hasClass('flickity-enabled')) { $g.flickity('resize'); }
      var $thumbs = $('.product_gallery_nav');
      if ($thumbs.length && $thumbs.hasClass('flickity-enabled')) { $thumbs.flickity('resize'); }
    } catch (e) {}
  }
  function hardRecoverGallery(reason) {
    try {
      var $g = $('.js-product-gallery');
      if (!$g.length) return false;
      if ($g.hasClass('flickity-enabled')) { try { $g.flickity('destroy'); } catch (e) {} }
      var $thumbs = $('.product_gallery_nav');
      if ($thumbs.length && $thumbs.hasClass('flickity-enabled')) { try { $thumbs.flickity('destroy'); } catch (e) {} }
      if (typeof window.productPage !== 'undefined' && typeof window.productPage.init === 'function') {
        window.productPage.init();
        console.log('[theme] Gallery hard-recovered (' + reason + ')');
        return true;
      }
    } catch (e) { console.warn('[theme] Hard recovery failed:', e); }
    return false;
  }
  function diagnoseAndRecover(label) {
    var $g = $('.js-product-gallery');
    if (!$g.length) return;
    var initialized = $g.hasClass('flickity-enabled');
    var galleryHeight = $g.height() || 0;
    var wrapHeight = $('.gallery-wrap').height() || 0;
    var cells = $g.find('.gallery-cell').length;
    var tooTall = galleryHeight > 1100 || wrapHeight > 1300;
    var tooShort = galleryHeight < 50 && cells > 0;
    if (!initialized || tooTall || tooShort) {
      forceLoadGalleryImages();
      softResizeGallery();
      setTimeout(function () {
        var newH = $g.height() || 0;
        var stillBroken = !$g.hasClass('flickity-enabled') || newH > 1100 || (newH < 50 && cells > 0);
        if (stillBroken) {
          hardRecoverGallery(label + ': soft failed');
        } else {
          console.log('[theme] Gallery soft-recovered (' + label + ')');
        }
      }, 100);
    } else {
      softResizeGallery();
    }
  }
  setTimeout(function () { diagnoseAndRecover('500ms'); }, 500);
  setTimeout(function () { diagnoseAndRecover('1500ms'); }, 1500);
  setTimeout(function () { diagnoseAndRecover('3000ms'); }, 3000);
  setTimeout(function () { diagnoseAndRecover('5000ms'); }, 5000);
  window.addEventListener('load', function () { setTimeout(function () { diagnoseAndRecover('window.load'); }, 300); });
  if (typeof MutationObserver !== 'undefined') {
    var productContainer = document.querySelector('.product-container, .js-product-section, [data-section-type="product-template"]');
    if (productContainer) {
      var mutationTimer = null;
      var observer = new MutationObserver(function () {
        clearTimeout(mutationTimer);
        mutationTimer = setTimeout(function () {
          forceLoadGalleryImages();
          softResizeGallery();
        }, 350);
      });
      observer.observe(productContainer, { childList: true, subtree: true });
    }
  }
  $(document).on('lazyloaded load', '.js-product-gallery img, .product_gallery_nav img', function () {
    softResizeGallery();
  });

  /* Re-run recovery when editor reloads sections (navigating between products) */
  $(document).on('shopify:section:load', function (e) {
    var sectionType = e.target && e.target.getAttribute && e.target.getAttribute('data-section-type');
    var isProduct = sectionType === 'product-template' ||
                    (e.target && e.target.querySelector && e.target.querySelector('[data-section-type="product-template"]')) ||
                    (e.target && e.target.classList && e.target.classList.contains('shopify-section--product-template'));
    console.log('[theme] section:load fired for', sectionType || (e.target && e.target.id) || 'unknown');
    if (isProduct || sectionType === 'apps') {
      setTimeout(function () { diagnoseAndRecover('section:load+0.5s'); }, 500);
      setTimeout(function () { diagnoseAndRecover('section:load+2s'); }, 2000);
      setTimeout(function () { diagnoseAndRecover('section:load+4s'); }, 4000);
    }
  });

  /* Catch URL changes from editor's pjax-style navigation between products */
  var lastPath = location.pathname;
  setInterval(function () {
    if (location.pathname !== lastPath) {
      console.log('[theme] URL changed from', lastPath, 'to', location.pathname);
      lastPath = location.pathname;
      setTimeout(function () { diagnoseAndRecover('url-change+1s'); }, 1000);
      setTimeout(function () { diagnoseAndRecover('url-change+3s'); }, 3000);
    }
  }, 500);
  if (window.PXUTheme.currency.show_multiple_currencies || window.PXUTheme.currency.native_multi_currency) {
    window.currencyConverter.init();
  }

  // Challenge page scroll

  // Return the pathname of the current URL
  const {
    pathname
  } = location;

  // If the pathname starts with '/challenge', animate scroll
  if (pathname.startsWith('/challenge')) {
    $('html, body').animate({
      scrollTop: 0
    }, 'slow');
  }

  // Setup a timer
  let resizeTimeout;
  // Grab screen width before screen is resized
  const beforeResizeWidth = $(window).width();

  // Listen for resize events
  window.addEventListener('resize', () => {
    // If timer is null, reset it to 66ms and run your functions.
    // Otherwise, wait until timer is cleared
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(() => {
        // Reset timeout
        resizeTimeout = null;
        // Grab screen width after screen is resized
        const currentScreenWidth = $(window).width();
        // Run our resize functions
        if (window.PXUTheme.media_queries.medium.matches && currentScreenWidth !== beforeResizeWidth) {
          window.cart.init();
          if (!window.is_touch_device()) {
            if ($('.main-nav__wrapper.sticky_nav').length > 0) window.header.unload();
            window.header.init();
          }
        }
        window.logoList.init();

        // swap lazysizes background mobile images when browser is resized
        const lazysizesBackgroundImages = document.querySelectorAll('[data-bg]');
        lazysizesBackgroundImages.forEach(image => {
          let bg = image.getAttribute('data-bg');
          const mobileBg = image.getAttribute('data-mobile-bg');
          if (bg) {
            if (window.PXUTheme.media_queries.medium.matches && mobileBg) {
              bg = mobileBg;
            }
            image.style.backgroundImage = `url(${bg})`;
          }
        });
      }, 66);
    }
  }, false);

  // Lightbox default options
  // https://fancyapps.com/fancybox/3/docs/#options
  if (typeof window.__restoreThemeJQuery === 'function') { window.__restoreThemeJQuery(); }
  if (typeof $ !== 'undefined' && $.fancybox && $.fancybox.defaults) {
  $.fancybox.defaults.animationEffect = 'fade';
  $.fancybox.defaults.transitionEffect = 'fade';
  $.fancybox.defaults.hash = false;
  $.fancybox.defaults.infobar = false;
  $.fancybox.defaults.toolbar = false;
  $.fancybox.defaults.arrows = false;
  $.fancybox.defaults.loop = true;
  $.fancybox.defaults.smallBtn = true;
  $.fancybox.defaults.live = false;
  $.fancybox.defaults.zoom = false;
  $.fancybox.defaults.mobile.preventCaptionOverlap = false;
  $.fancybox.defaults.mobile.toolbar = true;
  $.fancybox.defaults.mobile.buttons = ['close'];
  $.fancybox.defaults.mobile.clickSlide = 'close';
  $.fancybox.defaults.mobile.clickContent = 'zoom';
  $.fancybox.defaults.afterLoad = function (instance, slide) {
    if (instance.current.type === 'image') {
      slide.$content.wrapInner("<div class='fancybox-image-wrap'></div>");
    }
    if (instance.group.length > 1) {
      slide.$content.find('.fancybox-image-wrap').append(`<a title="Previous" class="fancybox-item fancybox-nav fancybox-prev" href="javascript:;" data-fancybox-prev><span>${window.svgArrowSizeLeft}</span></a><a title="Next" class="fancybox-item fancybox-nav fancybox-next" href="javascript:;" data-fancybox-next><span>${svgArrowSizeRight}</span></a>`);
    }
  };

  // backwards compatibility with custom lightboxes
  if (typeof $.fn.fancybox === 'function') {
    $('.lightbox[rel="gallery"]').fancybox();
  }
  } else {
    console.warn('[theme] $.fancybox unavailable; skipping fancybox config (an app may have replaced jQuery)');
  }

  // Find youtube and vimeo iframes
  const $videoIframes = $('iframe[src*="youtube.com"], iframe[src*="vimeo.com"], iframe[src*="facebook.com/plugins/video"]');

  // For each iframe, if parent is a responsive video wrapper do nothing
  // If no parent responsive video wrapper, then wrap iframe in responsive video wrapper

  function getAspectRatio(width, height) {
    const ratio = width / height;

    // Determine ratio to be used
    if (Math.abs(ratio - 1 / 1) === 0) {
      return '1:1';
    }
    return Math.abs(ratio - 4 / 3) < Math.abs(ratio - 16 / 9) ? '4:3' : '16:9';
  }
  $videoIframes.each((_index, iframe) => {
    // Update selector
    const $iframe = $(iframe);

    // Grab src
    const source = $iframe.attr('src');
    if (!$iframe.parents('.plyr__video-wrapper').length && !$iframe.parents('.lazyframe').length) {
      $iframe.wrap(`<div class="lazyframe" data-ratio="${getAspectRatio($iframe.attr('width'), $iframe.attr('height'))}" data-src="${source}"></div>`);
    }
  });

  // Initiate lazyframe
  window.lazyframe('.lazyframe');

  // Wrap shopify policy in grid layout classes
  $('.shopify-policy__container').wrap('<section class="section shopify-policy-template"><div class="container content"></div>');

  // Add classes to determine column size
  $('.shopify-policy__container').addClass('five-eighths offset-by-three columns is-hidden-offset-mobile-only medium-down--one-whole');

  // Add featured divider beneath page title
  $('.shopify-policy__title').append('<div class="feature-divider"></div>');

  // Collection sorting

  const sortByEl = document.querySelector('[data-sort-by]');
  if (sortByEl) {
    sortByEl.addEventListener('change', e => {
      const {
        target
      } = e;
      const sortValue = target.value;
      if (target) {
        // Set the query string and redirect
        const queryString = new URLSearchParams(document.location.search);
        queryString.set('sort_by', sortValue);
        window.location.search = queryString;
      }
    });
  }
  $('body').on('change', '#tag_filter', () => {
    $('[data-option-filter] input').prop('checked', false);
    window.quickFilter.init();
  });
  $('body').on('change', '#blog_filter', function () {
    const url = $(this).val();
    window.location = url;
  });
  
  function isInAppWebView() {
  var ua = navigator.userAgent || '';
  return /Instagram/.test(ua) || /FBAN|FBAV/.test(ua);
}

$('input, select, textarea').on('focus blur', event => {
  if (isInAppWebView()) return;
  $('meta[name=viewport]').attr('content', `width=device-width,initial-scale=1,maximum-scale=${event.type === 'blur' ? 10 : 5}`);
});

  // Collection sidebar filter
  // Check the checkbox values
  $('body').on('change', '[data-option-filter] input', () => {
    window.quickFilter.init();
    $('html, body').animate({
      scrollTop: $('.content').offset().top
    }, 500);
  });
  $('body').on('click', '[data-reset-filters]', () => {
    window.collectionSidebarFilter.clearAllFilters();
  });
  $('body').on('click', '[data-clear-filter]', e => {
    const $this = $(e.currentTarget);
    const selectedOption = $this.parents('.filter-active-tag');
    window.collectionSidebarFilter.clearSelectedFilter(selectedOption);
  });
  $('body').on('change', '.currencies', () => {
    $('[data-initial-modal-price]').attr('data-initial-modal-price', '');
  });
  $('body').on('change', '.js-quick-shop select', () => {
    const currentVariant = $('.js-quick-shop select[name="id"]').val();
    if (currentVariant && window.globalQuickShopProduct) {
      window.quickShop.updateVariant(currentVariant);
    }
  });
  if (window.PXUTheme.theme_settings.quick_shop_enabled) {
    window.quickShop.init();
  }
  let touchStartPos = 0;

  // Detecting swipe vs tap
  $(document).bind('touchstart', () => {
    touchStartPos = $(window).scrollTop();
  }).bind('touchend', e => {
    const distance = touchStartPos - $(window).scrollTop();
    if (distance > 20 || distance < -20) {
      e.preventDefault;
    }
  });
  $('body').on('click', '.sidebar .parent-link--false', function (e) {
    e.preventDefault();
    const $menu = $(this).parent('li');
    $menu.find('.menu-toggle').toggleClass('active');
    $menu.find('ul').slideToggle();
  });
  if (window.PXUTheme.theme_settings.newsletter_popup) {
    window.newsletter_popup.init();
  }
  if (window.PXUTheme.theme_settings.enable_back_to_top_button) {
    window.back_to_top_button.init();
  }
  if (window.location.pathname.indexOf('/comments') !== -1) {
    $('html,body').animate({
      scrollTop: $('#new-comment').offset().top - 140
    }, 'slow');
  }
  if (window.PXUTheme.media_queries.large.matches) {
    $('.animate_right').waypoint(function () {
      $(this.element).addClass('animated fadeInRight');
    }, {
      offset: '70%'
    });
    $('.animate_left').waypoint(function () {
      $(this.element).addClass('animated fadeInLeft');
    }, {
      offset: '70%'
    });
    $('.animate_up').waypoint(function () {
      $(this.element).addClass('animated fadeInUp');
    }, {
      offset: '70%'
    });
    $('.animate_down').waypoint(function () {
      $(this.element).addClass('animated fadeInDown');
    }, {
      offset: '70%'
    });
  }

  // backwards compatibility with flexslider
  $('.slider, .flexslider').find('li').unwrap();
  $('.slider, .flexslider').flickity({
    pageDots: window.usePageDots,
    imagesLoaded: true,
    arrowShape: window.arrowSize,
    lazyLoad: 2
  });
  window.utils.createAccordion('.footer_menu', 'h3', 'ul');
  window.utils.createAccordion('.footer_content', 'h3', 'div.toggle_content');
  window.utils.createAccordion('.product_section .accordion-tabs', '.tabs li > a', '.tabs-content li');
  window.utils.mobileParentActiveAccordion('#mobile_menu', 'li.sublink > a.parent-link--true span');
  window.utils.mobileAccordion('#mobile_menu', 'li.sublink > a');
  window.utils.initializeTabs();
  window.accordion.init();
  $('body').on('click', '.menu-toggle', function () {
    const $content = $(this).next('ul');
    $content.slideToggle();
    $(this).toggleClass('active');
    $(this).attr('aria-expanded', $(this).attr('aria-expanded') === 'true' ? 'false' : 'true');
  });
  if (window.PXUTheme.theme_settings.collection_swatches) {
    if (window.PXUTheme.media_queries.large.matches) {
      $('body').on('mouseenter', '.collection_swatches', function () {
        $('.swatch span', $(this)).each(function () {
          if ($(this).data('image').indexOf('no-image') === -1) {
            $('<img/>')[0].src = $(this).data('image');
          }
        });
      });
      $('body').on('mouseenter', '.swatch span', function () {
        if ($(this).data('image').indexOf('no-image') === -1) {
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('src', $(this).data('image'));
          $(this).parents('.thumbnail').find('.image__container img:not(.secondary)').attr('srcset', $(this).data('image'));
        }
      });
    }
  }

  // Terms of service settings for minicart
  if (window.PXUTheme.theme_settings.display_tos_checkbox) {
    $('body').on('click touchstart', '.cart_content .tos_label', function () {
      $(this).prev('input').prop('checked', true);
    });
  }
  if (window.PXUTheme.theme_settings.display_tos_checkbox && window.PXUTheme.theme_settings.go_to_checkout) {
    // Terms of service on mini-cart && cart page
    $('body').on('click', '.tos_warning [data-cart-checkout-button]', function (e) {
      if ($(this).parents('form').find('.tos_agree').is(':checked')) {
        // Check if we are on the cart page or mini cart
        if (window.PXUTheme.theme_settings.go_to_checkout || $('body').hasClass('cart')) {
          $(this).submit();
        } else {
          // Redirect to cart page
          e.preventDefault();
          document.location.href = window.PXUTheme.routes.cart_url;
        }
      } else {
        const warning = `<p class="warning animated bounceIn">${window.PXUTheme.translation.agree_to_terms_warning}</p>`;
        if ($('p.warning').length === 0) {
          $(this).before(warning);
        }
        return false;
      }
    });
  } else if (!window.PXUTheme.theme_settings.go_to_checkout) {
    $('body').on('click', '.cart_content [data-minicart-checkout-button]', e => {
      // Redirect to cart page
      e.preventDefault();
      document.location.href = window.PXUTheme.routes.cart_url;
    });
  }
  if (window.PXUTheme.theme_settings.collection_secondary_image) {
    window.imageFunctions.showSecondaryImage();
  }

  // Contact form checkbox validation
  if ($('[data-is-required]').length) {
    const $checkboxGroup = $('.custom-contact__checkbox');
    $checkboxGroup.prop('required', true);
    $checkboxGroup.on('change', () => {
      $checkboxGroup.prop('required', true);
      if ($checkboxGroup.is(':checked')) {
        $checkboxGroup.prop('required', false);
      }
    });
  }
  $('.maps').click(() => {
    $('.maps iframe').css('pointer-events', 'auto');
  });

  // Load more / infinite load

  if (window.PXUTheme.theme_settings.pagination_type === 'load_more') {
    window.enableLoadMoreProducts();
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'load_more_button') {
    window.enableLoadMoreButton('[data-product-list]');
  }
  if (window.PXUTheme.theme_settings.pagination_type === 'infinite_scroll') {
    window.enableInfiniteScroll('[data-product-list]');
  }

  /*= ===========================================================================
    Start of cart-related functionality
  ============================================================================== */

  function ajaxSubmitCart(cart) {
    const $cart = cart;
    $.ajax({
      url: '/cart/update.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: $cart.serialize(),
      success(data) {
        refreshCart(data);
      }
    });
  }
  function updateCartItemQuantity(cartItem) {
    $.ajax({
      url: '/cart/change.js',
      dataType: 'json',
      cache: false,
      type: 'post',
      data: {
        quantity: cartItem.quantity,
        line: cartItem.lineID
      },
      success(data) {
        const cartItemsArray = data.items;
        const lineIDIndex = cartItem.lineID - 1;
        const totalCartItems = cartItem.parentCartForm.find('[data-variant-id]').length;
        const $quantityInputs = cartItem.parentCartForm.find(`[data-variant-id="${cartItem.variantID}"] input`);
        let initialQuantityTotal = 0;
        let apiQuantityTotal = 0;
        const apiLineItemQuantity = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;

        // Check if item has a "Buy X get Y" deal
        if ($quantityInputs.length > 1) {
          // Multiple inputs

          // Get all the quantities of same variants in the cart (including BOGO) in HTML
          $.each($quantityInputs, (_i, input) => {
            initialQuantityTotal += parseInt($(input).val());
          });

          // Get quantities from cart object returned from API
          cartItemsArray.forEach(item => {
            if (item.variant_id === cartItem.variantID) {
              apiQuantityTotal += item.quantity;
            }
          });
        } else {
          // Single input
          initialQuantityTotal = parseInt($quantityInputs.val());
          apiQuantityTotal = typeof data.items[lineIDIndex] !== 'undefined' ? data.items[lineIDIndex].quantity : 0;
        }

        // Checks to see if there is enough inventory to update to an increased amount
        if (initialQuantityTotal > 0 && initialQuantityTotal > apiQuantityTotal) {
          if (apiQuantityTotal === 1) {
            itemsLeftText = window.PXUTheme.translation.one_item_left;
          } else {
            itemsLeftText = window.PXUTheme.translation.items_left_text;
          }
          $('.warning--quantity').remove();

          // Check if Buy one get one product
          if (totalCartItems < cartItemsArray.length) {
            if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
              // Refreshes cart if inventory is available
              cartItem.parentCartForm.submit();
            } else {
              refreshCart(data);
            }
          } else {
            const warning = `<p class="warning warning--quantity animated bounceIn">${apiQuantityTotal} ${itemsLeftText}</p>`;
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).parent().after(warning);
            cartItem.parentCartForm.find(`[data-line-id='${cartItem.lineID}'] input`).val(apiLineItemQuantity);
          }
        } else if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
          // Refreshes cart if inventory is available
          cartItem.parentCartForm.submit();
        } else {
          refreshCart(data);
        }
      }
    });
  }
  function refreshCartID() {
    const cartItem = document.querySelectorAll('.cart__item');
    for (let i = 0; i < cartItem.length; i++) {
      const lineIndex = i + 1;
      const dataLineId = cartItem[i].querySelectorAll('[data-line-id]');
      for (let c = 0; c < dataLineId.length; c++) {
        dataLineId[c].dataset.lineId = lineIndex;
      }
    }
  }
  function refreshCart(cart) {
    $('.cart_count').empty();
    const $cartBtn = $('.cart_count');
    const value = $cartBtn.text() || '0';
    let cartItemsHTML = '';
    let cartDiscountsHTML = '';
    let cartActionHTML = '';
    let cartSavingsHTML = '';
    const $cartForm = $('[data-cart-form]');
    let productHasSale = false;
    let productCompareAtPrice = 0;
    let productFinalPrice = 0;
    $cartForm.data('total-discount', cart.total_discount);
    $cartBtn.text(value.replace(/[0-9]+/, cart.item_count));
    if (cart.item_count === 0) {
      $('.js-empty-cart__message').removeClass('hidden');
      $cartForm.addClass('hidden');
    } else {
      $('.js-empty-cart__message').addClass('hidden');
      $cartForm.removeClass('hidden');
      let totalSaving = 0; // adding counter variables for total cart savings
      let saving = 0;
      $.each(cart.items, (index, item) => {
        const itemDiscounts = item.discounts;
        let discountMessage = '';
        for (let i = 0; i < itemDiscounts.length; i++) {
          const {
            title
          } = itemDiscounts[i];
          discountMessage = `<p class="notification-discount meta">${title}</p>`;
        }
        const lineID = index + 1;
        cartItemsHTML += `<li class="mini-cart__item" data-cart-item data-line-id="${lineID}" data-variant-id="${item.id}">` + `<a href="${item.url}">`;
        if (item.image) {
          cartItemsHTML += `${'<div class="cart_image">' + '<img src="'}${item.image.replace(/(\.[^.]*)$/, '_compact$1').replace('http:', '')}" alt="${htmlEncode(item.title)}" />` + '</div></a>';
        }
        cartItemsHTML += `<div class="mini-cart__item-content"><div class="mini-cart__item-title"><a href="${item.url}">${item.title}</a>`;
        if (item.selling_plan_allocation) {
          cartItemsHTML += `<div class="meta">${item.selling_plan_allocation.selling_plan.name}</div>`;
        }
        if (item.properties) {
          cartItemsHTML += '<div class="mini-cart__item-properties">';
          $.each(item.properties, (title, value) => {
            if (value && value !== 'on') {
              cartItemsHTML += `<div class="mini-cart__item-property">${title}: ${value}</div>`;
            }
          });
          cartItemsHTML += '</div>';
        }
        cartItemsHTML += '</div><div class="mini-cart__item-price">';
        $.ajax({
          dataType: 'json',
          async: false,
          cache: false,
          url: `${window.Shopify.routes.root}products/${item.handle}.js`,
          success(data) {
            let productData = data;
            // If item has more than one variant, need to make sure we are pulling data from the correct variant
            if (productData.variants) {
              const itemVariants = productData.variants;
              if (itemVariants.length > 1) {
                for (let v = 0; v < itemVariants.length; v++) {
                  if (itemVariants[v].id === item.id) {
                    productData = itemVariants[v];
                  }
                }
              }
            }

            // If compare at price exists then item is on sale
            if (productData.compare_at_price && productData.compare_at_price > productData.price) {
              productHasSale = true;
              productCompareAtPrice = productData.compare_at_price;
              productFinalPrice = productData.price;
            } else {
              // Check required for non-sale items
              productHasSale = false;
            }
          }
        });
        if (productHasSale === true) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(productFinalPrice, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(productCompareAtPrice, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;

          // Total savings
          saving = (productCompareAtPrice - productFinalPrice) * item.quantity;
          totalSaving = saving + totalSaving;
        } else if (item.price > item.final_price) {
          // puts the slash through the old item price
          const itemPrice = `${window.Shopify.formatMoney(item.final_price, $('body').data('money-format'))} </span><span class="money was_price">${window.Shopify.formatMoney(item.price, $('body').data('money-format'))}</span>`;
          cartItemsHTML += `<span class="money sale">${itemPrice}</strong>`;
        } else {
          const itemPrice = window.Shopify.formatMoney(item.final_price, $('body').data('money-format'));
          if (item.final_price > 0) {
            cartItemsHTML += `<span class="money">${itemPrice}</span></strong>`;
          } else {
            cartItemsHTML += `<span>${window.PXUTheme.translation.cart_free_text}</span></strong>`;
          }
        }
        cartItemsHTML += '</div>';

        // Unit price

        if (item.unit_price_measurement && item.price > 0) {
          let unitPriceMeasurementReferenceValue = '';
          if (item.unit_price_measurement.reference_value !== 1) {
            unitPriceMeasurementReferenceValue = item.unit_price_measurement.reference_value;
          }
          cartItemsHTML += `<p class="mini-cart__unit-price">${item.unit_price_measurement.quantity_value}${item.unit_price_measurement.quantity_unit} | ${Shopify.formatMoney(item.unit_price, $('body').data('money-format'))} / ${unitPriceMeasurementReferenceValue}${item.unit_price_measurement.reference_unit}</p>`;
        }
        if (item.price > item.final_price) {
          cartItemsHTML += discountMessage;
        }
        cartItemsHTML += '<div class="product-quantity-box">';
        cartItemsHTML += '<span class="ss-icon product-minus js-change-quantity" data-func="minus"><span class="icon-minus"></span></span>';
        cartItemsHTML += `<input type="number" min="0" class="quantity" name="updates[]" id="updates_${item.id}" value="${item.quantity}" data-cart-quantity-input="mini-cart" />`;
        cartItemsHTML += '<span class="ss-icon product-plus js-change-quantity" data-func="plus"><span class="icon-plus"></span></span>';
        cartItemsHTML += '</div></div></div>';
        cartItemsHTML += `<a href="/cart/change?line=${lineID}&amp;quantity=0" class="js-cart-remove-btn cart__remove-btn" data-line-id="${lineID}" data-remove-item="mini-cart"><span class="remove-icon"></span></a>`;
      });
      const cartDiscounts = cart.cart_level_discount_applications;
      for (let i = 0; i < cartDiscounts.length; i++) {
        const amount = window.Shopify.formatMoney(cartDiscounts[i].total_allocated_amount, $('body').data('money-format'));
        const {
          title
        } = cartDiscounts[i];
        cartDiscountsHTML += `<span class="cart_discounts--title">${title}</span>`;
        cartDiscountsHTML += '<span class="cart_discounts--price">';
        cartDiscountsHTML += `-<span class="money">${amount}</span></span>`;
      }
      cartActionHTML += `<span class="right"><span class="money">${window.Shopify.formatMoney(cart.total_price, $('body').data('money-format'))}</span></span> <span>${window.PXUTheme.translation.cart_subtotal_text}</span>`;
      totalSaving += cart.total_discount;
      if (window.PXUTheme.theme_settings.display_savings && totalSaving > 0) {
        cartSavingsHTML = `<span class="right"><span class="money">${window.Shopify.formatMoney(totalSaving, $('body').data('money-format'))}</span></span>` + `<span>${window.PXUTheme.translation.cart_savings_text}</span>`;
      } else {
        cartSavingsHTML = '';
      }
    }
    $('.js-cart_items').html(cartItemsHTML);
    $('.js-cart_discounts').html(cartDiscountsHTML);
    $('.js-cart_subtotal').html(cartActionHTML);
    $('.js-cart_savings').html(cartSavingsHTML);

    // Converting the currencies
    if (window.PXUTheme.currency.show_multiple_currencies) {
      window.currencyConverter.convertCurrencies();
    }
  }
  $('body').on('change', '[data-cart-quantity-input]', function () {
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: $(this).val(),
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    // Disable button after click to prevent multiple clicks
    $(this).parents('.product-quantity-box').find('.js-change-quantity').addClass('is-disabled');
    updateCartItemQuantity(cartItem);
  });
  $('body').on('click', '[data-remove-item]', function (e) {
    e.preventDefault();
    const cartItem = {
      lineID: $(this).parents('[data-cart-item]').data('line-id'),
      variantID: $(this).parents('[data-cart-item]').data('variant-id'),
      quantity: 0,
      parentCartForm: $(this).parents('[data-cart-form]'),
      totalDiscount: $(this).parents('[data-cart-form]').data('total-discount'),
      $element: $(this).parents('[data-cart-item]')
    };
    cartItem.$element.addClass('animated fadeOutLeft');
    updateCartItemQuantity(cartItem);
    if (cartItem.parentCartForm.data('cart-form') === 'cart-template') {
      cartItem.$element.find('input').val('0');
      cartItem.parentCartForm.submit();
    }
    if (cartItem.parentCartForm.data('cart-form') === 'mini-cart') {
      cartItem.$element.find('input').val('0');
    }
  });
  if (window.PXUTheme.theme_settings.cart_action === 'ajax') {
    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      const $addToCartBtn = $addToCartForm.find('.add_to_cart');
      this.recipientForm = $addToCartForm[0].querySelector('[data-recipient-form]');
      $('.warning').remove();
      if (this.recipientForm) {
        this.recipientForm.classList.remove('recipient-form--has-errors');
      }

      // Refresh page on quick shop add to cart if on cart page
      if ($('body').hasClass('cart')) {
        $addToCartForm.submit();
      }
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend() {
          $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
          $addToCartBtn.find('span').removeClass('fadeInDown').addClass('animated zoomOut');
        },
        success() {
          $addToCartBtn.find('.checkmark').addClass('checkmark-active');
          window.setTimeout(() => {
            $addToCartBtn.removeAttr('disabled').removeClass('disabled');
            $addToCartBtn.find('.checkmark').removeClass('checkmark-active');
            $addToCartBtn.find('span').removeClass('zoomOut').addClass('fadeInDown');
          }, 1000);
          $.ajax({
            url: '/cart.js',
            dataType: 'json',
            cache: false,
            success(cart) {
              setTimeout(function () {
                refreshCart(cart);
                if ($('body').hasClass('fancybox-active')) {
                  $.fancybox.close();
                }
                if ($('#header').is(':visible')) {
                  $('#header .cart-container').addClass('active_link');
                } else if ($('.sticky_nav--stick').length) {
                  $('.sticky_nav .cart-container').addClass('active_link');
                } else {
                  $('.top-bar .cart-container').addClass('active_link');
                }

                // block scrolling on mobile
                if (window.PXUTheme.media_queries.medium.matches) {
                  const $cartContainer = $(this).parent();
                  if ($cartContainer.hasClass('active_link')) {
                    $('body').addClass('blocked-scroll');
                  } else {
                    $('body').addClass('blocked-scroll');
                  }

                  // Scroll to the top of the page unless the header is fixed
                  const header = document.getElementById('header');
                  if (header.classList.contains('mobile_nav-fixed--false')) {
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }
              }, 500);
            }
          });
        },
        error: XMLHttpRequest => {
          const response = eval(`(${XMLHttpRequest.responseText})`);
          $('.warning').remove();
          let warning;
          if (response.errors && response.errors.email) {
            this.recipientForm.classList.add('recipient-form--has-errors');
          } else {
            warning = `<p class="warning animated bounceIn">${response.description.replace('All 1 ', 'All ')}</p>`;
            $addToCartForm.after(warning);
          }
          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
          $addToCartBtn.find('span').text(window.PXUTheme.translation.add_to_cart).removeClass('zoomOut').addClass('zoomIn');
        }
      });
      return false;
    });
  }
  window.productPage.productSwatches();
});

/*= ===========================================================================
  Swatch options - second and third swatch 'sold-out' will update based on availability of previous options selected
============================================================================== */
window.Shopify.updateOptionsInSelector = function (selectorIndex, parent) {
  switch (selectorIndex) {
    case 0:
      var key = 'root';
      break;
    case 1:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      break;
    case 2:
      var key = $(`${parent} .single-option-selector:eq(0)`).val();
      key += ` / ${$(`${parent} .single-option-selector:eq(1)`).val()}`;
  }
  const availableOptions = Shopify.optionsMap[key];
  $(`${parent} .swatch[data-option-index="${selectorIndex}"] .swatch-element`).each(function () {
    if ($.inArray($(this).attr('data-value'), availableOptions) !== -1) {
      $(this).removeClass('soldout').find(':radio').removeAttr('disabled', 'disabled').removeAttr('checked');
    } else {
      $(this).addClass('soldout').find(':radio').removeAttr('checked').attr('disabled', 'disabled');
    }
  });
};
window.Shopify.linkOptionSelectors = function (product, parent) {
  // Building our mapping object.
  window.Shopify.optionsMap = {};
  for (let i = 0; i < product.variants.length; i++) {
    const variant = product.variants[i];
    if (variant.available) {
      // Gathering values for the 1st drop-down.
      window.Shopify.optionsMap.root = window.Shopify.optionsMap.root || [];
      window.Shopify.optionsMap.root.push(variant.option1);
      window.Shopify.optionsMap.root = window.Shopify.uniq(window.Shopify.optionsMap.root);
      // Gathering values for the 2nd drop-down.
      if (product.options.length > 1) {
        const key = variant.option1;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option2);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
      // Gathering values for the 3rd drop-down.
      if (product.options.length === 3) {
        const key = `${variant.option1} / ${variant.option2}`;
        window.Shopify.optionsMap[key] = window.Shopify.optionsMap[key] || [];
        window.Shopify.optionsMap[key].push(variant.option3);
        window.Shopify.optionsMap[key] = window.Shopify.uniq(window.Shopify.optionsMap[key]);
      }
    }
  }
  // Update options right away.
  window.Shopify.updateOptionsInSelector(0, parent);
  if (product.options.length > 1) window.Shopify.updateOptionsInSelector(1, parent);
  if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
  // When there is an update in the first dropdown.
  $(`${parent} .single-option-selector:eq(0)`).change(() => {
    window.Shopify.updateOptionsInSelector(1, parent);
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
  // When there is an update in the second dropdown.
  $(`${parent} .single-option-selector:eq(1)`).change(() => {
    if (product.options.length === 3) window.Shopify.updateOptionsInSelector(2, parent);
    return true;
  });
};

// Used for cart functionality
window.htmlEncode = function htmlEncode(value) {
  if (value) {
    return $('<div/>').text(value).html();
  }
  return '';
};

// Check if device is touch-enabled
window.is_touch_device = function is_touch_device() {
  return 'ontouchstart' in window || navigator.maxTouchPoints;
};

// Differentiate between mobile and touch screen laptops
window.touch_device = /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent);

// [glg-fix] 2026-09-18 — Shopify Planet decorative icons ship with no alt
// attribute at all (SC 1.1.1). This markup comes from the app's own
// extension bundle, not theme code, so it's patched here in the DOM
// instead of edited directly (an app update could overwrite it).
(function () {
  var DECORATIVE_PLANET_ASSETS = ['phone.svg', 'car.svg', 'header-splash.svg'];

  function fixPlanetAlts(root) {
    (root || document).querySelectorAll('img[src*="/extensions/"][src*="planet"]').forEach(function (img) {
      if (img.hasAttribute('alt')) return;
      var filename = img.src.split('/').pop().split('?')[0];
      if (DECORATIVE_PLANET_ASSETS.indexOf(filename) !== -1) {
        img.setAttribute('alt', '');
      }
    });
  }

  function initPlanetAltFix() {
    fixPlanetAlts();
    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) { fixPlanetAlts(m.target); });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlanetAltFix);
  } else {
    initPlanetAltFix();
  }
})();

/******/ })()
;